/**
 * أدوات تشغيل أصوات الإشعارات
 */

// إنشاء صوت تنبيه بسيط باستخدام Web Audio API
export const playNotificationSound = (type: 'info' | 'warning' | 'error' = 'info') => {
  try {
    // التحقق من دعم المتصفح للـ Audio Context
    const AudioContext = window.AudioContext || (window as any).webkitAudioContext;
    if (!AudioContext) {
      console.warn('Audio Context not supported');
      return;
    }

    const audioContext = new AudioContext();
    
    // تحديد تردد الصوت حسب نوع التنبيه
    let frequency: number;
    let duration: number;
    
    switch (type) {
      case 'error':
        frequency = 800; // صوت منخفض للأخطاء
        duration = 0.3;
        break;
      case 'warning':
        frequency = 1000; // صوت متوسط للتحذيرات
        duration = 0.2;
        break;
      case 'info':
      default:
        frequency = 1200; // صوت عالي للمعلومات
        duration = 0.15;
        break;
    }

    // إنشاء oscillator للصوت
    const oscillator = audioContext.createOscillator();
    const gainNode = audioContext.createGain();
    
    // ربط العقد
    oscillator.connect(gainNode);
    gainNode.connect(audioContext.destination);
    
    // تعيين خصائص الصوت
    oscillator.frequency.setValueAtTime(frequency, audioContext.currentTime);
    oscillator.type = 'sine';
    
    // تعيين مستوى الصوت مع تأثير fade out
    gainNode.gain.setValueAtTime(0.1, audioContext.currentTime);
    gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + duration);
    
    // تشغيل الصوت
    oscillator.start(audioContext.currentTime);
    oscillator.stop(audioContext.currentTime + duration);
    
  } catch (error) {
    console.warn('Could not play notification sound:', error);
  }
};

// تشغيل صوت تنبيه للديون المتأخرة
export const playDebtOverdueSound = () => {
  playNotificationSound('error');
};

// تشغيل صوت تنبيه للديون القريبة من الاستحقاق
export const playDebtDueSoonSound = () => {
  playNotificationSound('warning');
};

// تشغيل صوت تنبيه عام
export const playGeneralNotificationSound = () => {
  playNotificationSound('info');
};

// تشغيل سلسلة أصوات للتنبيهات المهمة
export const playUrgentDebtAlert = () => {
  playDebtOverdueSound();
  setTimeout(() => playDebtOverdueSound(), 200);
  setTimeout(() => playDebtOverdueSound(), 400);
};

// التحقق من إعدادات الصوت في المتصفح
export const canPlayNotificationSounds = (): boolean => {
  try {
    const AudioContext = window.AudioContext || (window as any).webkitAudioContext;
    return !!AudioContext;
  } catch {
    return false;
  }
};

// إعدادات الصوت المحفوظة في localStorage
export const getSoundSettings = () => {
  const settings = localStorage.getItem('notificationSoundSettings');
  if (settings) {
    return JSON.parse(settings);
  }
  return {
    enabled: true,
    debtAlerts: true,
    maintenanceAlerts: true,
    generalAlerts: false
  };
};

export const setSoundSettings = (settings: any) => {
  localStorage.setItem('notificationSoundSettings', JSON.stringify(settings));
};

// تشغيل صوت مع التحقق من الإعدادات
export const playConditionalSound = (type: 'debt' | 'maintenance' | 'general', soundType: 'info' | 'warning' | 'error' = 'info') => {
  const settings = getSoundSettings();
  
  if (!settings.enabled) return;
  
  switch (type) {
    case 'debt':
      if (settings.debtAlerts) {
        playNotificationSound(soundType);
      }
      break;
    case 'maintenance':
      if (settings.maintenanceAlerts) {
        playNotificationSound(soundType);
      }
      break;
    case 'general':
      if (settings.generalAlerts) {
        playNotificationSound(soundType);
      }
      break;
  }
};
